import React from 'react';
import Switch from './Switch';

interface AutoRefreshToggleProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
}

export default function AutoRefreshToggle({ enabled, onToggle }: AutoRefreshToggleProps) {
  return (
    <div
      className="flex items-center gap-3"
      title={enabled ? 'Disable polling for account status updates' : 'Enable polling for account status updates'}
    >
      <span className="text-sm text-dataops-primary-dark-blue">Auto-refresh:</span>
      <Switch enabled={enabled} setEnabled={onToggle} />
      <span className={`text-sm font-medium ${enabled ? 'text-green-600' : 'text-gray-700'}`}></span>
    </div>
  );
}
